import styled from 'styled-components';

export const ResetContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    height: 100%;
    min-width: 500px;
    padding: 0 8px;
`;

export const FormContainer = styled.form`
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    margin-top: 50px;
`;

export const EmailContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const ContainerFields = styled.fieldset`
    display: flex;
    flex-direction: column;
    margin-bottom: 48px;
    width: 100%;
    gap: 20px;
`;

export const FormGroup = styled.div`
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 40px;
`;
